import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAutoMatchProfileQualifiersSection extends Layout {
    labelQualifiers: Label;
    panelQualifierSummary: Panel;
    panelQualifiers: Panel;
    sourceEquipmentMatch: DataSource;
    textboxCommodity: Textbox;
    textboxSummaryConsignee: Textbox;
    textboxSummaryCustomer: Textbox;
    textboxSummaryLocation: Textbox;
    textboxSummaryName: Textbox;
    textboxSummaryOrderMode: Textbox;
    textboxSummaryOrderType: Textbox;
    textboxSummaryRevenueCode: Textbox;
    textboxSummaryShipper: Textbox;
    textboxSummaryTrailerType: Textbox;
}
